import { useField } from 'formik';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import QuestionGrade from './QuestionGrade';

const QuestionGradeContainer = (props) => {
  const { t } = useTranslation();
  const [{ value: grade }, , { setValue: setGrade }] = useField('grade');
  const handleEvaluation = useCallback((number) => {
    setGrade(number);
  }, [setGrade]);
  return (
    <QuestionGrade
      grade={grade}
      handleEvaluation={handleEvaluation}
      t={t}
      {...props}
    />
  );
};

QuestionGradeContainer.propTypes = {
  handleModalClose: PropTypes.func.isRequired,
};

export default QuestionGradeContainer;
